import './scss/index.scss'
import {SelectComponent} from './SelectComponent'

const SelectPackage = {
    name: 'UISelect',
    configure: function(config) {
        config.addComponent('UISelect', SelectComponent, false, 'select')
    }
}

export {SelectPackage}
